import apiUrl from "../../../../utils/settings";

export const GetNotificationPaginUrl = () => {
  return (
    apiUrl + '/user-notification-history/get-notification-history-paginated'
  );
};
